import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useWidget } from 'pages/Dashboards/hooks/useWidgets';
import { WidgetData } from 'pages/Dashboards/interfaces';

export const useLoadWidget = (widgetId: string, globalFilters: any) => {
  const params = useParams();
  const { dashboardId } = params;
  const { getWidgetQuery } = useWidget({
    apiParams: {
      widgetId,
      dashboardId,
      data: { filters: globalFilters },
    },
  });

  useEffect(() => {
    getWidgetQuery.refetch();
  }, [globalFilters]);

  const data = getWidgetQuery?.data || {};
  const widgetData = data?.data || [];
  const widget = data?.widget || {};
  const parsedData = useMemo(() => {
    return widgetData?.map((d: any) => {
      const { valueX, valueY, ...rest } = d;
      return {
        valueX: valueX,
        valueY: Number(valueY),
        ...rest,
      };
    });
  }, [data]);

  return { parsedData, getWidgetQuery, widget };
};
